import React from 'react'
import { Stack, useTheme } from '@mui/system'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  legendItem: {
    display: 'flex',
    flexDirection: 'row',
    height: theme.spacing(3),
    width: 'fit-content',
  },
  colorBlock: {
    maxWidth: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
  },
}))

//* Legend for the dynamic power price chart. */
interface DynamicEmsChartLegendProps {
  isDynamicEmsDataLoading: boolean
}

const DynamicEmsChartLegend: React.FC<DynamicEmsChartLegendProps> = ({ isDynamicEmsDataLoading }) => {
  const theme = useTheme()
  const chartColors = theme.palette.dppWidget

  return (
    <Stack gap={2} sx={{ mt: 2, mr: 2, mb: 4, ml: 2, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
      <DynamicEmsChartLegendItem
        isLine
        color={chartColors.consumptionPriceColor}
        captionKey="dashboard.liveView.widgets.dynamic-power-price.legend.power-price"
      />
      {!isDynamicEmsDataLoading && (
        <>
          <DynamicEmsChartLegendItem
            color={chartColors.dynamicEmsNormalOperationColor}
            captionKey="dashboard.liveView.widgets.dynamic-power-price.legend.normal-operation"
          />
          <DynamicEmsChartLegendItem
            color={chartColors.dynamicEmsBlockDischargingColor}
            captionKey="dashboard.liveView.widgets.dynamic-power-price.legend.discharging-blocked"
          />
          <DynamicEmsChartLegendItem
            color={chartColors.dynamicEmsGridChargeColor}
            captionKey="dashboard.liveView.widgets.dynamic-power-price.legend.charging-from-grid"
          />
        </>
      )}
    </Stack>
  )
}

interface DynamicEmsChartLegendItemProps {
  color: string
  captionKey: string
  isLine?: boolean
}
//* Single legend item for the dynamic power price chart. */
const DynamicEmsChartLegendItem: React.FC<DynamicEmsChartLegendItemProps> = ({ color, captionKey, isLine }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const theme = useTheme()
  return (
    <Stack className={classes.legendItem} sx={{ display: 'flex', alignItems: 'center', minWidth: 'fit-content' }}>
      {!isLine && (
        <Stack
          component="div"
          className={classes.colorBlock}
          sx={{ background: color, width: theme.spacing(3), height: theme.spacing(3), marginRight: theme.spacing(1) }}
        />
      )}
      {isLine && (
        <Stack
          component="div"
          className={classes.colorBlock}
          sx={{
            background: theme.palette.grey.grey07,
            width: theme.spacing(3),
            height: theme.spacing(3),
            marginRight: theme.spacing(1),
            justifyContent: 'center',
          }}
        >
          <Stack sx={{ background: color, width: theme.spacing(3), height: theme.spacing(0.5) }} />
        </Stack>
      )}

      <Typography variant="caption">{t(captionKey)}</Typography>
    </Stack>
  )
}

export default DynamicEmsChartLegend
